import styled from 'styled-components'

const StyledCaptionList = styled.div`
  .caption-list {
    display: grid;
    row-gap: 12px;
    margin-top: 20px;
  }

  .empty-state {
    margin-top: 100px;
    padding: 0 20px;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.m}px) {
    .caption-list {
      display: grid;
      row-gap: 12px;
      column-gap: 12px;
      margin-top: 40px;
      grid-template-columns: 1fr 1fr 1fr;
    }
  }
`

export default StyledCaptionList
